import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['text', 'icon'];
var baseStyleText = {
  color: 'red.700',
  mt: 2,
  fontWeight: 600,
  letterSpacing: 'tight'
};
var baseStyleIcon = {
  marginRight: 2,
  color: 'red.700'
};
var baseStyle = {
  text: baseStyleText,
  icon: baseStyleIcon
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});